export type Brand = 'SEEK' | 'JobStreet' | 'JobsDB';

export type Locale = 'AU' | 'NZ' | 'HK' | 'TH' | 'MY' | 'SG' | 'PH' | 'ID';

export type Language = 'th' | 'en' | 'id';

export type VocabLanguage =
  | 'en-AU'
  | 'en-NZ'
  | 'en-HK'
  | 'en-TH'
  | 'th-TH'
  | 'en-MY'
  | 'en-SG'
  | 'en-PH'
  | 'en-ID'
  | 'id-ID';

export type Zone =
  | 'anz-1'
  | 'anz-2'
  | 'asia-1'
  | 'asia-3'
  | 'asia-4'
  | 'asia-5'
  | 'asia-6'
  | 'asia-7';

export enum Site {
  SEEKAU = 'candidate-seek-au',
  SEEKNZ = 'candidate-seek-nz',
  JOBSDBHK = 'candidate-jobsdb-hk',
  JOBSDBTH = 'candidate-jobsdb-th',
  JOBSTREETMY = 'candidate-jobstreet-my',
  JOBSTREETSG = 'candidate-jobstreet-sg',
  JOBSTREETPH = 'candidate-jobstreet-ph',
  JOBSTREETID = 'candidate-jobstreet-id',
}

export interface BaseConfig {
  BRAND: Brand;
  LOCALE: Locale;
  ENV: string;
  OAUTH_ENV: 'prod' | 'dev';
  USE_ANALYTICS: boolean;
  ANALYTICS_ENV: string;
  SEEK_SOL_TRACKING_ENDPOINT: string;
  MISSING_JOB: string;
  METRICS_ENABLED: boolean;
  METRICS_URL: string;
  LMIS_URL: string;
  LMIS_ENABLED: boolean;
  DATADOG_BROWSER_LOG_ENABLED: boolean;
  SIGN_IN_PAGE: string;
  ZONE: Zone;
  CERTSY_ENABLED: boolean;
  LINKOUT_SERVICE_URL: string;
}

interface DynamicConfig {
  JOB_ID: string;
  SITE: Site;
  LANGUAGE: Language;
  LOCALE: string;
  VERSION: string;
  VOCAB_LANGUAGE: VocabLanguage;
  GRAPHQL_ENDPOINT: string | undefined;
  ROUTE: string;
  AUTH_OVERRIDE?: string;
}

export type Config = DynamicConfig & BaseConfig;

declare global {
  interface Window {
    CONFIG: Config;
    Cypress: Record<string, unknown>;
    SEEK_TEST: boolean;
    TEST_USER: boolean;
  }
}

export const INVALID_JOB_ERROR = 'INVALID_JOB' as const;
export const JOB_NOT_FOUND_ERROR = 'JOB_NOT_FOUND' as const;
export const QUESTIONNAIRE_FETCH_ERROR = 'QUESTIONNAIRE_FETCH_ERROR' as const;
